// extracted by mini-css-extract-plugin
export default {"Container":"SuccessModal_Container__9huPP","Secondary":"SuccessModal_Secondary__zGKK9","Primary":"SuccessModal_Primary__Y6PTO"};